// @ts-nocheck

import React from 'react';
import styled from 'styled-components';

import OverlayTransitionGroup from '../../animations/OverlayTransitionGroup';

const Background = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  padding: 0;
  margin: 0;
  background: ${({ backgroundColor }) => backgroundColor ?? '#000'};
  opacity: ${({ opacity }) => opacity ?? 0.2};
  z-index: 10000;
`;

type OverlayProps = {
  isOpen: boolean;
  backgroundColor?: string;
  opacity?: number;
};

const Overlay = ({ isOpen, backgroundColor, opacity }: OverlayProps) => {
  return (
    <OverlayTransitionGroup opacity={opacity}>
      {isOpen ? <Background backgroundColor={backgroundColor} opacity={opacity} /> : null}
    </OverlayTransitionGroup>
  );
};

export default Overlay;
